import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { InfoBoxType } from '@/models/InfoBox';
import BCXSidebarOrLayer from '@/components/molecules/BCXSidebarOrLayer.vue';
import useI18n from '@/mixins/useI18n';
import useInvoiceActionState from '@/views/my-projects/components/invoices/action-box/useInvoiceActionState';
import InvoicesActionButtons from '@/views/my-projects/components/invoices/action-box/InvoicesActionButtons.vue';
import InvoicesNewInvoiceAction from '@/views/my-projects/components/invoices/action-box/InvoicesNewInvoiceAction.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoicesActions',
  props: {
  inBox: Boolean
},
  setup(__props) {

const { mode } = useInvoiceActionState();
const { t } = useI18n();

const infoBoxType = computed(() => (mode.value === 'new-invoice' ? InfoBoxType.INFOBOX_APPLY : InfoBoxType.INFOBOX_STANDARD));

const hasBackButton = computed(() => mode.value === 'new-invoice');



const onNewInvoice = () => {
  mode.value = 'new-invoice';
};

const title = computed(() => (mode.value === 'new-invoice' ? `${t('invoices.actions.create-invoice.title')}` : `${t('invoices.actions.sidebar-title')}`));

return { __sfc: true,mode, t, infoBoxType, hasBackButton, onNewInvoice, title, BCXSidebarOrLayer, InvoicesActionButtons, InvoicesNewInvoiceAction }
}

})